<template>
  <router-view></router-view>
  <AuthLoadingOverlay />
  <AccessDeniedModal />
</template>

<script>
import AuthLoadingOverlay from '@/components/AuthLoadingOverlay.vue';
import AccessDeniedModal from '@/components/AccessDeniedModal.vue';

export default {
  name: 'App',
  components: {
    AuthLoadingOverlay,
    AccessDeniedModal,
  }
};
</script>
